import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  // {
  //   path: "/:equipmentCode/:processId/:equipmentId/:tenantId",
  //   name: "Daily",
  //   component: () => import("@/views/daily/Process.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(),
  // history: createWebHashHistory(),
  routes,
});

export default router;
